import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
//import useUndoRedo from "../App/useUndoRedo";

export const IdeationButton = ({
  ideationMode,
  handleSetIdeationMode,
}: {
  ideationMode: boolean;
  handleSetIdeationMode: (mode: boolean) => void;
}) => {
  const [isChecked, setIsChecked] = useState(false);
  //const { takeSnapshot } = useUndoRedo();

  useEffect(() => {
    setIsChecked(ideationMode);
  }, [ideationMode]);

  useEffect(() => {
    handleSetIdeationMode(isChecked);
  }, [isChecked]);

  const handleActivateIdeationMode = () => {
    //takeSnapshot();
    setIsChecked((prev) => !prev);
  };

  return (
    <Button
      onClick={handleActivateIdeationMode}
      className="p-button-text p-button-plain"
      tooltip="Spread Out"
      tooltipOptions={{ position: "bottom" }}
      style={{
        width: "2.5rem",
        height: "2.5rem",
        color: isChecked ? "#14b8a6" : "#6c757d",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "0px",
        right: "0px",
      }}
    >
      <i className="pi pi-sun" style={{ fontSize: "1.5rem" }} />
    </Button>
  );
};
